import { useState } from 'react';
import './Blog.scss';

const AstroBlog = () => {
  const [openPost, setOpenPost] = useState(null);

  const toggleReadMore = (index) => {
    setOpenPost(openPost === index ? null : index);
  };

  const posts = [
    {
      title: "Daily Horoscope: Aries",
      excerpt: "Today, the stars align for bold decisions and spontaneous actions. Embrace the unexpected!",
      details: `Aries is governed by Mars, a planet traditionally linked to action, drive, and assertiveness. In astrology, Aries natives are seen as ambitious, direct, and sometimes impulsive. They're encouraged to take initiative but also warned to temper their fiery energy with patience. While horoscopes often highlight themes like courage and new beginnings, it's important to recognize that these interpretations are symbolic, not predictive. There's no scientific evidence that daily planetary alignments directly affect human decision-making or emotional patterns — but many people find value in the metaphorical guidance astrology offers.`
    },
    {
      title: "Full Moon in Capricorn",
      excerpt: "Embrace structure and discipline under tonight’s moon. Perfect time to finalize long-term goals.",
      details: `The Full Moon in Capricorn is symbolically linked with responsibility, structure, and discipline. It’s considered a time to reassess goals, commit to long-term visions, and take practical steps forward. Astrologers often associate Capricorn with ambition and endurance, and the full moon phase is seen as a peak moment of energy and clarity. Scientifically, a full moon occurs when the Earth is positioned between the Sun and Moon, making the Moon appear fully illuminated from our perspective. While studies haven’t proven any direct psychological or behavioral influence, people throughout history have ascribed spiritual significance to this lunar event.`
    },
    {
      title: "Mercury Retrograde Survival Tips",
      excerpt: "Communication may be tricky. Learn how to stay grounded and avoid misunderstandings.",
      details: `Mercury Retrograde is a period when the planet Mercury appears to move backward in the sky due to differences in orbital speed. Astrologically, this is seen as a time when communication, travel, and technology may experience disruptions. Common advice includes double-checking emails, avoiding major purchases, and being mindful during discussions. Though there's no scientific basis for Mercury affecting mechanical or digital systems, the psychological impact is real — many people attribute increased stress or mishaps to this period, creating a feedback loop. For those who follow astrology, retrogrades are also framed as a time for introspection, review, and rethinking past decisions.`
    }
  ];

  return (
    <div className="astro-blog">
      <header className="hero">
        <h1>Astrology Insights & Horoscopes</h1>
        <p>Your cosmic guide to daily life, archetypes, and spiritual growth.</p>
      </header>

      <div className="content">
        <section className="posts">
          {posts.map((post, idx) => (
            <article key={idx} className="post-card">
              <h2>{post.title}</h2>
              <p>{post.excerpt}</p>
              {openPost === idx && <p className="details">{post.details}</p>}
              <button className="read-more" onClick={() => toggleReadMore(idx)}>
                {openPost === idx ? "Read Less" : "Read More"}
              </button>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
};

export default AstroBlog;
